<template>
  <div>
    <page-main
      :tableData="tableData"
      :loading="loading"
      :disabled="disabled"
      @reload="reload"
    >
      <page-header
        ref="header"
        slot="header"
        :disabled="disabled"
        @query="getData"
        @reset="resetPage"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import BaseTable from '@/mixins/base-table'
export default {
  mixins: [BaseTable],
  components: { PageMain, PageHeader },
  props: {
    disabled: { type: Boolean, default: false },
    evgSkuCode: { type: String, default: '' },
  },
  data() {
    return { usePage: true }
  },
  methods: {
    getData(form) {
      if (!this.evgSkuCode) return
      this.loading = true
      this.$api
        .ecomEvgSkuPlatformListApi({
          ...form,
          evgSkuCode: this.evgSkuCode,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
}
</script>
